import React from 'react'
import { useSelector } from 'react-redux'

import Layout from 'components/Layout'
import HomeWorkingCN from './HomeWorkingCN'
import HomeGuest from './HomeGuest'
import OnboardingFlow from 'screens/onboarding/OnboardingFlow'
import OnboardingFlowInvited from 'screens/onboarding/OnboardingFlowInvited'
import TourPrompt from 'screens/onboarding/tour/TourPrompt'

const Home = () => {
	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo: user } = userLogin

	if (!user) {
		return null
	}

	const isGuest = user?.role === 'guest'
	if (isGuest) {
		return (
			<Layout>
				<HomeGuest />
			</Layout>
		)
	}

	const isFirstTime = user?.firstTime
	const isInvited = user?.isInvited

	return (
		<>
			<HomeWorkingCN />
			{isFirstTime && isInvited && <OnboardingFlowInvited />}
			{isFirstTime && !isInvited && <OnboardingFlow />}
			{!isFirstTime && <TourPrompt />}
		</>
	)
}

export default Home
